import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { render } from 'react-dom';
import i18n from './i18n';
import './index.scss';
import App from './App';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
// import reportWebVitals from './reportWebVitals';

const vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://bc38c3d9ca8a418e99a940e6d568a75b@o524542.ingest.sentry.io/5708570',
    integrations: [new Integrations.BrowserTracing()],
    release: 'kyoungpay@' + process.env.npm_package_version,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}

i18n.on('initialized', () => {
  render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root'),
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
